import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { Button, Card, Col, Row } from 'react-bootstrap';
import FalconCardHeader from 'components/common/FalconCardHeader';
import AuthContext from 'context/authContext';
import { useParams } from 'react-router-dom';
import AddLog from './AddLog';
import { toast } from 'react-toastify';
import dayjs from 'dayjs';
import { getWeraiseModule, getLogs, insertLog } from 'lib/supabaseQueries';

const Logs = ({ moduleType }) => {
  const { organization } = useContext(AuthContext);
  const { id } = useParams();
  const queryClient = useQueryClient();

  const [showAddLog, setShowAddLog] = useState(false);

  const { data: weraiseData } = useQuery({
    queryKey: ['weraiseModule', moduleType],
    queryFn: () => getWeraiseModule(moduleType),
    enabled: !!moduleType
  });

  const weraiseModule = weraiseData?.data;

  const { data: logsData } = useQuery({
    queryKey: ['logs', organization?.id, weraiseModule?.id, id],
    queryFn: () => getLogs(organization.id, weraiseModule.id, id),
    enabled: !!organization?.id && !!weraiseModule?.id && !!id
  });

  const addLogMutation = useMutation({
    mutationFn: insertLog,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['logs'] });
      toast.success('Log Added Successfully');
      setShowAddLog(false);
    },
    onError: error => {
      toast.error('Something went wrong');
      console.error(error);
    }
  });

  const submitAddLog = data => {
    addLogMutation.mutate({
      weraise_module_id: weraiseModule?.id,
      organisation_id: organization.id,
      module_reference_id: id,
      ...data
    });
  };

  return (
    <Card className="mb-3">
      <FalconCardHeader
        title={<h4 className="fw-bold"> Log </h4>}
        light={false}
        titleTag="div"
        className="pb-1"
        menuClassName="align-items-start"
        endEl={<Button onClick={() => setShowAddLog(true)}>Add Update</Button>}
      />

      <Card.Body>
        {logsData?.data?.map(log => (
          <div key={log.id}>
            <Row>
              <Col>
                <div>
                  <p className="mb-1">
                    {' '}
                    {dayjs(log.created_at).format('DD/MM/YYYY')}
                  </p>
                  <p className="mb-1 h6"> {log.subject} </p>
                  <p className="mb-1">{log.message}</p>
                </div>
              </Col>
            </Row>
            <hr />{' '}
          </div>
        ))}
      </Card.Body>

      {showAddLog && (
        <AddLog
          show={showAddLog}
          onSubmit={data => {
            submitAddLog(data);
          }}
          onHide={() => {
            setShowAddLog(false);
          }}
          title={'Add Log'}
          loading={addLogMutation.isPending}
        />
      )}
    </Card>
  );
};

Logs.propTypes = {
  moduleType: PropTypes.string
};

export default Logs;
